import type React from 'react';

import { ArrowInCircleRightIcon } from '@vlabs/icons';
import { routes } from '@vlabs/shared/navigation/routes';
import { Control } from '@vlabs/uikit';
import type { IconButtonProps } from '@vlabs/uikit/components/controls/button/icon-button';
import { useHistory, generatePath } from 'react-router-dom';

import type { ListId } from '@vlabs/api/luna-api/model';
import { buildTestid } from '../../shared/lib/utils';

const displayName = 'GoToListIconButton';
const testid = buildTestid(displayName);

interface GoToListButtonProps extends IconButtonProps {
  listId: ListId;
}

function GoToListButton({
  listId,
  'data-testid': dataTestId = undefined,
  ...props
}: GoToListButtonProps): React.JSX.Element {
  const history = useHistory();

  const goToList = () => {
    history.push(generatePath(routes.lists.read, { listId }));
  };

  return (
    <Control.IconButton
      icon={<ArrowInCircleRightIcon />}
      kind="secondary"
      onClick={goToList}
      variant="flat"
      {...testid(listId, dataTestId)}
      {...props}
    />
  );
}

GoToListButton.displayName = displayName;

export { GoToListButton };
